import styled from "styled-components";

import { colors } from "components";

interface IProps {
  widthHeight?: number;
}

export const Container = styled.button<IProps>`
  width: ${(props) => (props.widthHeight ? props.widthHeight + "px" : "40px")};
  height: ${(props) => (props.widthHeight ? props.widthHeight + "px" : "40px")};
  background-color: ${colors.default_blue};
  border-radius: 50%;
  border: 2px ${colors.default_blue} solid;
  cursor: pointer;

  &:hover {
    border-color: ${colors.default_base_white};
    background: ${colors.default_dark_blue};
  }
`;

export const PlusIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.default_base_white};
  font-size: 20px;
`;
